import { render, staticRenderFns } from "./CampaignNew.vue?vue&type=template&id=5de301aa&scoped=true&"
import script from "./CampaignNew.vue?vue&type=script&lang=ts&"
export * from "./CampaignNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de301aa",
  null
  
)

export default component.exports